/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    List,
    ListItem,
    Heading,
    useMultiStyleConfig,
    Button,
    Divider,
    Link
} from '@salesforce/retail-react-app/app/components/shared/ui'
// import Link from '@salesforce/retail-react-app/app/components/link'
import {pxToRem} from '../../utills/pxToRem'
import {ChevronRightIcon} from '../icons'

const LinksList = ({
    links = [],
    isMainContent = false,
    isInnerMenu = false,
    categoryData,
    heading = '',
    hasSubMenu,
    variant,
    color,
    onLinkClick,
    headingLinkRef,
    setfeatureImage,
    setSelectedLevelOneMenu,
    selectedLevelTwoMenu,
    selectedLevelOneMenu,
    setSelectedLevelTwoMenu,
    setLinksForLevelTwoMenu,
    setLinksForLevelThreeMenu,
    setIsLevelTwoMenuOpen,
    setIsLevelThreeMenuOpen,
    setLinksForContentComp,
    setFeatureImageMobileLevelTwo,
    setFeatureImageMobileLevelThree,
    setFeatureImageMobileLevelFour,
    setMenuToggle,
    isMobileMenu,
    parentCategoryName,
    ...otherProps
}) => {
    const styles = useMultiStyleConfig('LinksList', {variant})

    const onLevelOneClick = (id, text) => {
        let selectedLevelTwoMenu = {}
        if (id) {
            selectedLevelTwoMenu = links?.find((item) => item.id === id)
        }

        if (isInnerMenu) {
            setIsLevelThreeMenuOpen(true)
            setFeatureImageMobileLevelFour(heading?.image)
            setLinksForLevelThreeMenu(selectedLevelTwoMenu?.categories)
            setSelectedLevelTwoMenu(heading)
        } else if (isMainContent) {
            setLinksForContentComp(categoryData)
            setFeatureImageMobileLevelTwo(heading.image)
        } else {
            setIsLevelTwoMenuOpen(true)
            setLinksForLevelTwoMenu(categoryData?.categories)
            setSelectedLevelOneMenu(heading)
            setFeatureImageMobileLevelThree(heading?.image)

            setLinksForLevelThreeMenu([])
            setIsLevelThreeMenuOpen(false)

            setSelectedLevelTwoMenu({})
        }

        if (window?.dataLayer) {
            window.dataLayer.push({
                event: 'mainNavClick',
                valueL1: parentCategoryName,
                valueL2: text
            })
        }
    }

    const updateGTMdataLayer = (categoryName) => {
        if (window?.dataLayer) {
            window.dataLayer.push({
                event: 'mainNavClick',
                valueL1: parentCategoryName,
                valueL2: categoryName
            })
        }
    }

    return (
        <Box {...styles.container} {...(color ? {color: color} : {})} {...otherProps}>
            {heading &&
                (hasSubMenu ? (
                    <>
                        <Button
                            onClick={() => onLevelOneClick(heading.id, heading.text)}
                            ref={headingLinkRef}
                            {...styles.headingLink}
                            _hover={{
                                textDecoration: 'none'
                            }}
                            _active={{
                                backgroundColor: 'transparent'
                            }}
                            backgroundColor={'transparent'}
                            height={'auto'}
                            paddingTop={{
                                base: pxToRem(10),
                                sm: pxToRem(10),
                                md: pxToRem(0),
                                lg: pxToRem(0)
                            }}
                            paddingBottom={{
                                base: pxToRem(10),
                                sm: pxToRem(10),
                                md: pxToRem(0),
                                lg: pxToRem(0)
                            }}
                            paddingLeft={'0'}
                            paddingRight={{
                                base: pxToRem(0),
                                sm: pxToRem(0),
                                md: pxToRem(15),
                                lg: pxToRem(15)
                            }}
                            color={'black'}
                            width={'100%'}
                        >
                            <Heading
                                {...styles.heading}
                                fontSize={[pxToRem(14), pxToRem(14), pxToRem(13), pxToRem(13)]}
                                fontWeight={
                                    isMainContent
                                        ? '600'
                                        : (heading?.id == selectedLevelTwoMenu?.id ||
                                              heading?.id == selectedLevelOneMenu?.id) &&
                                          !isMobileMenu
                                        ? '700'
                                        : '400'
                                }
                                padding={[0, 0, 0, 0]}
                                paddingRight={{
                                    base: pxToRem(18),
                                    sm: pxToRem(18),
                                    md: pxToRem(0),
                                    lg: pxToRem(0)
                                }}
                            >
                                {heading.text}
                            </Heading>

                            {hasSubMenu && (
                                <ChevronRightIcon
                                    boxSize={pxToRem(14)}
                                    color="black"
                                    marginLeft={[
                                        pxToRem(10),
                                        pxToRem(10),
                                        pxToRem(10),
                                        pxToRem(10)
                                    ]}
                                    sx={{
                                        '& use': {
                                            transform: {
                                                base: 'scale(1.7)',
                                                sm: 'scale(1.7)',
                                                md: 'scale(1.5)',
                                                lg: 'scale(1.5)'
                                            },
                                            transformOrigin: 'center',
                                            stroke: 'currentColor',
                                            strokeWidth: '1'
                                        }
                                    }}
                                />
                            )}
                        </Button>
                    </>
                ) : (
                    <Link
                        href={heading?.c_alternativeUrl ? heading?.c_alternativeUrl : heading.href}
                        // to={heading?.c_alternativeUrl ? heading?.c_alternativeUrl : heading.href}
                        // onClick={menuClick}
                        onClick={() => updateGTMdataLayer(heading.text)}
                        ref={headingLinkRef}
                        {...styles.headingLink}
                        _hover={{
                            textDecoration: 'none'
                        }}
                        paddingTop={{
                            base: pxToRem(10),
                            sm: pxToRem(10),
                            md: pxToRem(0),
                            lg: pxToRem(0)
                        }}
                        paddingBottom={{
                            base: pxToRem(10),
                            sm: pxToRem(10),
                            md: pxToRem(0),
                            lg: pxToRem(0)
                        }}
                        paddingLeft={'0'}
                        paddingRight={{
                            base: pxToRem(18),
                            sm: pxToRem(18),
                            md: pxToRem(0),
                            lg: pxToRem(0)
                        }}
                    >
                        <Heading
                            {...styles.heading}
                            fontSize={[pxToRem(14), pxToRem(14), pxToRem(13), pxToRem(13)]}
                            fontWeight={isMainContent ? '600' : '400'}
                            padding={[0, 0, 0, 0]}
                        >
                            {heading.text}
                        </Heading>

                        {hasSubMenu && (
                            <ChevronRightIcon
                                marginLeft={[pxToRem(50), pxToRem(50), pxToRem(50), pxToRem(50)]}
                            />
                        )}
                    </Link>
                ))}
        </Box>
    )
}

LinksList.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string,
            text: PropTypes.string
        })
    ).isRequired,
    heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    hasSubMenu: PropTypes.oneOf[(true, false)],
    variant: PropTypes.oneOf(['vertical', 'horizontal']),
    color: PropTypes.string,
    onLinkClick: PropTypes.func,
    headingLinkRef: PropTypes.object,
    setfeatureImage: PropTypes.string,
    setSelectedLevelOneMenu: PropTypes.object,
    selectedLevelTwoMenu: PropTypes.func,
    selectedLevelOneMenu: PropTypes.func,
    setSelectedLevelTwoMenu: PropTypes.func,
    setLinksForLevelTwoMenu: PropTypes.array,
    categoryData: PropTypes.object,
    isInnerMenu: PropTypes.oneOf[(true, false)],
    setLinksForLevelThreeMenu: PropTypes.func,
    setIsLevelTwoMenuOpen: PropTypes.func,
    setIsLevelThreeMenuOpen: PropTypes.func,
    setLinksForContentComp: PropTypes.func,
    parentCategoryName: PropTypes.string,
    setFeatureImageMobileLevelTwo: PropTypes.func,
    setFeatureImageMobileLevelThree: PropTypes.func,
    setFeatureImageMobileLevelFour: PropTypes.func,
    setMenuToggle: PropTypes.func,
    isMobileMenu: PropTypes.oneOf[(true, false)],
    isMainContent: PropTypes.oneOf[(true, false)]
}

export default LinksList
